module.exports = __webpack_public_path__ + "static/media/import.a92e4449.svg";